import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { ObjectManager } from '../../../concepts/objects';
import { Reaction } from './Reaction';


export const clearReactions = defineCommand(
    'clearReactions',
    'Reactions: Clear',
    r => {
        const objects = r.call(ObjectManager);
        const all = objects.getAll(Reaction);

        objects.update(u => {
            for (const x of all) {
                x.removeSelf();
                u.delete(x);
            }
        });
    }
);
